import Card from "components/Card/Card";
import Chart from "react-apexcharts";

const ChartBar = ({ data }) => {
    return (

        <Chart
            options={data.options}
            series={data.series}
            type="area"
            width="100%"
            height="100%"
        />
    );
}

export default ChartBar;